<template>
    <header class="mobile-header" v-if="isMobile">
        <div class="mobile-header-content">
            <router-link to="/" class="mobile-logo">
                <img :src="finalWebsite && finalWebsite.logoFinal ? finalWebsite.logoFinal : '/assets/Weflix/logo_weflix.png'" alt="Logo Weflix" />
            </router-link>

            <div class="mobile-search">
                <input type="text" v-model="searchQuery" @input="getSearchCollection" placeholder="Buscar...">
                <button v-if="searchQuery" class="close-search-btn" @click="toggleSearch">
                    <fa icon="fa-xmark"/>
                </button>
                <button class="search-btn" @click="toggleSearch">
                    <fa icon="fa-magnifying-glass"/>
                </button>
            </div>

            <button class="menu-toggle" @click="toggleMobileMenu">
                <fa icon="fa-bars"/>
            </button>
        </div>

        <div class="mobile-sidebar" :class="{'active': showMobileMenu}">
            <div class="title-sidebar-mobile">
                <h4>{{finalWebsite.title}}</h4>
                <small>{{finalWebsite.description.slice(0,100)}}...</small>
            </div>
            <div class="sidebar-header">
                <button class="close-menu" @click="toggleMobileMenu">
                    <fa icon="fa-xmark"/>
                </button>
            </div>

            <nav class="sidebar-nav">
                <div class="title-sidebar-mobile">  
                    <p style="border-bottom: 1px solid rgba(255, 255, 255, 0.1);">Menu</p>
                </div>
                <a @click="handleLoginClick" v-if="!userPortalWeflix" style="color: white;">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="width: 17px; fill: white;"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480l384 0c-1.2-79.7-66.2-144-146.3-144l-91.4 0c-80 0-145 64.3-146.3 144zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"/></svg>
                    Entrar
                </a>
                <router-link to="/minha-conta" @click="toggleMobileMenu" v-if="userPortalWeflix">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="width: 17px; fill: white;"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480l384 0c-1.2-79.7-66.2-144-146.3-144l-91.4 0c-80 0-145 64.3-146.3 144zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"/></svg>
                  Olá, <span style="text-transform: capitalize;">{{ userPortalWeflix.user.name }}</span>
                </router-link>
                <router-link to="/" @click="toggleMobileMenu">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="width: 20px; fill: white;"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432l0-227.2L288 55.5 464 204.8 464 432c0 17.7-14.3 32-32 32l-48 0 0-152c0-22.1-17.9-40-40-40l-112 0c-22.1 0-40 17.9-40 40l0 152-48 0c-17.7 0-32-14.3-32-32zm128 32l0-144 96 0 0 144-96 0z"/></svg>
                    Página inicial
                </router-link>
                <router-link to="/colecoes" @click="toggleMobileMenu">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style="width: 20px; fill: white;"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M576 32L256 32c-17.7 0-32 14.3-32 32l0 169.4L297.4 160c12.5-12.5 32.8-12.5 45.3 0L384 201.4 489.4 96c12.5-12.5 32.8-12.5 45.3 0L608 169.4 608 64c0-17.7-14.3-32-32-32zm64 176c0 0 0 0 0 .1l0 80c0 35.3-28.7 64-64 64l-304 0c0 0 0 0 0 0l-16 0c-35.3 0-64-28.7-64-64l0-16s0 0 0 0l0-208c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 144zm-32 6.7l-96-96L395.3 235.3 310.6 320 576 320c17.7 0 32-14.3 32-32l0-73.4zM265.4 320l96-96L320 182.6l-96 96 0 9.4c0 17.7 14.3 32 32 32l9.4 0zM296 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM128 160l32 0 0 32-32 0 0 80 0 128 0 80 256 0 0-96 32 0 0 96 32 0c17.7 0 32-14.3 32-32l0-64 32 0 0 64c0 35.3-28.7 64-64 64l-32 0-16 0-16 0-256 0-16 0-16 0-32 0c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l32 0 16 0 16 0zM32 256l64 0 0-64-32 0c-17.7 0-32 14.3-32 32l0 32zm0 160l0 32c0 17.7 14.3 32 32 32l32 0 0-64-64 0zm64-32l0-96-64 0 0 96 64 0z"/></svg>
                    Coleções
                </router-link>
                <router-link to="/planos" @click="toggleMobileMenu">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="width: 20px; fill: white;"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM96 304c0 8.8 7.2 16 16 16l352 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-352 0c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0zM400 144l64 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8-8 8l-64 0c-4.4 0-8-3.6-8-8l0-48c0-4.4 3.6-8 8-8zm-40 8l0 48c0 22.1 17.9 40 40 40l64 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-64 0c-22.1 0-40 17.9-40 40z"/></svg>
                    Planos
                </router-link>
                <router-link to="/checkoutweflix" @click="toggleMobileMenu" v-if="itemCheckoutWeflix">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="width: 20px; fill: white;"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l37.9 0c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2L496 384c8.8 0 16-7.2 16-16s-7.2-16-16-16l-304.8 0c-15.2 0-28.3-10.7-31.4-25.6L152 288l314.6 0c29.4 0 55-20 62.1-48.5L570.6 71.8c5-20.2-10.2-39.8-31-39.8L99.1 32C92.5 13 74.4 0 53.9 0L16 0zm90.1 64l433.4 0L497.6 231.8C494 246 481.2 256 466.5 256l-321.1 0L106.1 64zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"/></svg>
                    Checkout
                </router-link>
                <router-link to="/checkout-collection-weflix" @click="toggleMobileMenu" v-if="collectionCheckout">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="width: 20px; fill: white;"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l37.9 0c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2L496 384c8.8 0 16-7.2 16-16s-7.2-16-16-16l-304.8 0c-15.2 0-28.3-10.7-31.4-25.6L152 288l314.6 0c29.4 0 55-20 62.1-48.5L570.6 71.8c5-20.2-10.2-39.8-31-39.8L99.1 32C92.5 13 74.4 0 53.9 0L16 0zm90.1 64l433.4 0L497.6 231.8C494 246 481.2 256 466.5 256l-321.1 0L106.1 64zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"/></svg>
                    Checkout
                </router-link>

                <div class="plans-side-mobile">
                  
                    <div v-if="plansWeflix.filter(p => p.planValue > 0).length > 0" class="plan-item">
                        <small style="color: white; text-transform: uppercase;">Comece agora</small>
                        <div class="plan-name">{{ plansWeflix.filter(p => p.planValue > 0).sort((a,b) => a.planValue - b.planValue)[0].name }}</div>
                        <div class="plan-price">R$ {{ plansWeflix.filter(p => p.planValue > 0).sort((a,b) => a.planValue - b.planValue)[0].planValue.toFixed(2) }}</div>
                        <div class="plan-period">{{ plansWeflix.filter(p => p.planValue > 0).sort((a,b) => a.planValue - b.planValue)[0].period === 'monthly' ? 'Mensal' : 'Anual' }}</div>
                        <button @click="goToCheckoutSubscribe" class="subscribe-btn sidebar-btn" :style="{ backgroundColor: finalWebsite.color }">
                            Assine agora
                        </button>
                    </div>
                   
                </div>
                <div>
                    <button class="subscribe-btn" @click="goToPlans">
                        Conheça nossos planos
                    </button>
                    
                </div>
               

                
            </nav>
        </div>
        <div class="degragre-background-sidebar-mobile" v-if="showMobileMenu"></div>
    </header>

    <header v-else>
        <div class="header">
            <div class="contentHeaderLeft">
                <router-link to="/" class="logo" :class="[activeSearch ? 'active':'']">
                    <img :src="finalWebsite && finalWebsite.logoFinal ? finalWebsite.logoFinal : '/assets/Weflix/logo_weflix.png'" alt="Logo Weflix" style="width: 120px;height: 60px;    padding: 10px;" />
                </router-link>

                <p class="collectionsMenu">
                    <router-link to="/">Home</router-link>
                </p>
                <p class="collectionsMenu">
                    <router-link to="/colecoes">Coleções</router-link>
                </p>
                <p class="collectionsMenu">
                    <router-link to="/planos">Planos</router-link>
                </p>
            </div>
            <div class="contentHeaderMiddle">
                <div class="search" :class="[activeSearch ? 'active':'']">
                    <input type="text" v-model="searchQuery" @input="getSearchCollection">
                    <button class="btnCloseSearch" @click="toggleSearch" v-show="activeSearch"><fa icon="fa-xmark"/></button>
                    <button class="btnSearch" @click="toggleSearch"><fa icon="fa-magnifying-glass"/></button>
                </div>
                <p @click="toggleModal" class="login" v-if="!userPortalWeflix">
                    <fa icon="fa-user"/>
                </p>
                <div v-if="userPortalWeflix && finalWebsite && finalWebsite.company && finalWebsite.company.cartStatus == 1 && !hasSinglePurchase" style="display: contents;">
                    <button class="btnHedaer" @click="toggleModalSubscribe" v-if="userPortalWeflix.user.orderStatus !==  1">Assine agora</button>
                </div>
                
                <div v-if="!userPortalWeflix && finalWebsite && finalWebsite.company && finalWebsite.company.cartStatus === 1 && !hasSinglePurchase" class="InfoOutLogin">
                    <button class="btnHedaer" @click="toggleModalSubscribe">Assine agora</button>
                </div>
                <div class="menuMobile" @click="showMenuMobile = !showMenuMobile" :class="[activeSearch ? 'active':'']" v-if="userPortalWeflix">
                    <fa icon="fa-user"/>
                </div>
            </div>
        </div>
        
        <div class="loggedInfo" v-if="userPortalWeflix ">
            <div class="itensMenu" :class="[showMenuMobile ? 'active':'']">
                <router-link to="/minha-conta" class="linkMenu" @click="showMenuMobile = false"><fa icon="fa-user"/>Minha conta</router-link>
                <p class="linkMenu" @click="logout"><fa icon="fa-power-off"/>Sair</p>
            </div>
        </div>
    </header>

    <div class="resultSearch" :class="[hasReadyResult ? 'active':'']" @click.self="toggleSearch">
        <div class="resultSearchItens">
            <!-- <div class="tabs">
                <button :class="['tab-btn', activeTab === 'collections' ? 'active' : '']" 
                        @click="activeTab = 'collections'">
                    Coleções
                </button>
                <button :class="['tab-btn', activeTab === 'videos' ? 'active' : '']" 
                        @click="activeTab = 'videos'">
                    Vídeos
                </button>
            </div> -->

            <div v-if="isLoading" class="loader-container">
                <div class="loader"></div>
            </div>

            <div class="tab-content" v-else-if="resultSearch">
                <div v-show="activeTab === 'collections'" class="grid-container">
                    <div class="grid-item" v-for="item in collectionsResult" :key="item.id" v-show="collectionsResult">
                        <router-link :to="`/colecoes-videos/themeLight/${item.id}`" @click="removeOverflow">
                            <div class="item-content">
                                <img v-if="item.imageFinalPath == null" src="@/assets/Weflix/default-video-thumbnail.jpg" alt="Imagem padrão">
                                <img v-else :src="item.imageFinalPath" alt="Capa do vídeo">
                                <img src="@/assets/gif/LOVEDEATHROBOTSVOLUME4_OfficialTeaser_Netflix-ezgif.com-video-to-gif-converter.gif" alt="GIF" class="gif-indicator">

                                <p>{{ item.comercialName }}</p>
                            </div>
                        </router-link>
                    </div>
                    <div class="notFound" v-show="!collectionsResult">
                        <p>Nenhum resultado encontrado</p>
                    </div>
                </div>

                <div v-show="activeTab === 'videos'" class="grid-container">
                    <div class="grid-item" v-show="videosResult.length > 0" v-for="item in videosResult" :key="item.id">
                        <div @click="validateUserAccess(item.id)">
                            <div class="item-content">
                                <img v-if="item.finalVideoThumbnail == null" src="@/assets/Weflix/default-video-thumbnail.jpg" alt="Imagem padrão">
                                <img v-else :src="item.finalVideoThumbnail" alt="Capa do vídeo">

                                <p>{{ item.title }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="notFound" v-show="videosResult.length == 0">
                        <p>Nenhum resultado encontrado</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ApiWebsite from '@/utils/Weflix/Website/index';
import ApiPayment from '@/utils/Weflix/Website/payment';
import plans from '@/utils/Weflix/Website/plans';

export default {
    data(){
        return{
            activeSearch:false,
            logo: null,
            description: null,
            showMenuMobile: false,
            searchQuery: '',
            hasReadyResult: false,
            resultSearch: null,
            collectionsResult: null,
            videosResult: null,
            activeTab: 'videos',
            isLoading: false,
            development: process.env.NODE_ENV === 'development' ? true : false,
            baseUrl: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_URL_HOMOLOGATION  : window.location.origin,
            selectedCompany: null,
            showMobileMenu: false,
            isMobile: window.innerWidth <= 768,
        }
    },
    computed:{
        ...mapState(['itemCheckoutWeflix','collectionCheckout','finalWebsite','userPortalWeflix', 'trialWeflix', 'activeTrial','companys', 'hasSinglePurchase', 'noLogin', 'plansWeflix']),
    },
    watch: {
        noLogin(newValue) {
            if(newValue === true && !this.userPortalWeflix) {
                this.$emit('toggleModalSubscribe');
                this.$emit('toggleModal');
            }
        }
    },
    methods:{
        ...mapActions(['logoutPortalWeflix', 'storeActiveTrial', 'storeFinalWebsite', 'storeNoLogin']),
        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu;
            document.body.style.overflow = this.showMobileMenu ? 'hidden' : '';
        },
        handleLoginClick() {
            this.toggleModal();
            this.toggleMobileMenu();
        },
        handleSubscribeClick() {
            this.toggleModalSubscribe();
            this.toggleMobileMenu();
        },
        handleLogoutClick() {
            this.logout();
            this.toggleMobileMenu();
        },
        async changeCompany(company) {
            if (company) {
                try {
                    await this.storeFinalWebsite({finalWebsite: company});
                    this.getInfoSite();
                } catch (error) {
                    console.error('Erro ao mudar empresa:', error);
                }
            }
        },
        validateUserAccess(videoId) {
            if (!this.userPortalWeflix) {
                console.log('entrou no if');
                this.hasReadyResult = false;
                this.toggleModal();
                return;
            } else if(this.userPortalWeflix.user.orderStatus !== 1){
                console.log('entrou no else if');
               this.$router.push(`/planos`);
                return;
            } else {
                console.log('entrou no else');
                this.removeOverflow();  
                this.hasReadyResult = false;
                this.$router.push(`/player/${videoId}`);
            }
          
        },
        toggleModal(){
           this.$emit('toggleModal');
        },
        toggleModalSubscribe(){
           this.$emit('toggleModalSubscribe');
        },
        async getSearchCollection() {
            if (this.searchQuery.length < 3) {
                this.hasReadyResult = false;
                this.resultSearch = null;
                this.collectionsResult = [];
                this.videosResult = [];
                return;
            }

            this.hasReadyResult = true;
            this.isLoading = true;
            const url = this.baseUrl.replace(/\/$/, '');
            const payload = {
                "url": url,
                "search": this.searchQuery
            }
           try {
                const response = await ApiWebsite.serachCollectionVideo(payload);
                this.hasReadyResult = true;
                this.resultSearch = response;
                this.collectionsResult = response.courses;
                this.videosResult = response.lessons;
                this.toggleBodyOverflow();
                this.lastSearch = this.searchQuery;
           } catch (error) {
                console.error('Erro ao obter dados da pesquisa:', error);
                this.hasReadyResult = false;
                this.resultSearch = null;
                this.collectionsResult = [];
                this.videosResult = [];
           } finally {
                this.isLoading = false;
           }
        },
        toggleSearch() {
            this.activeSearch = !this.activeSearch;
            this.hasReadyResult = false;
            this.searchQuery = '';
            this.collectionsResult = [];
            this.videosResult = [];
            this.toggleBodyOverflow();
        },
        toggleBodyOverflow() {
            if (this.hasReadyResult) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        },
        logout() {
            this.logoutPortalWeflix();
            window.location.href = '/';
           
        },
        removeOverflow(){
            document.body.style.overflow = '';
        },
        goToCheckoutSubscribe(){
            this.removeOverflow();
            // this.$router.push('/checkoutweflix');
        },
        async activeTrialUser(){
            try {
                const response = await ApiPayment.activeTrial(this.userPortalWeflix.acessToken);
                this.$store.dispatch('storeActiveTrial', {activeTrial: true});
                alert('Trial ativado com sucesso');
            } catch (error) {
                console.error('Erro ao ativar trial:', error);
            }
        },
        goToPlans(){
            this.removeOverflow();
            this.$router.push('/planos');
        },
        async getInfoSite(){
            if (!this.finalWebsite) {
                const aux = this.baseUrl.replace(/\/$/, '');
                const payload = {
                    "url": aux
                }
                try {
                    const response = await ApiWebsite.getWebsite(payload);
                    this.storeFinalWebsite({finalWebsite:response});
                    
                    document.title = response.title;
                    
                    const link = document.createElement('link');
                    link.rel = 'icon';
                    link.href = response.faviconFinal;
                    document.head.appendChild(link);
                    
                    if (response.css) {
                        const style = document.createElement('style');
                        style.textContent = response.css;
                        document.head.appendChild(style);
                    }
                    
                    if (response.javascript) {
                        const script = document.createElement('script');
                        script.textContent = response.javascript;
                        document.body.appendChild(script);
                    }

                    if (response.googleAnalyticsCode) {
                        const gaScript = document.createElement('script');
                        gaScript.async = true;
                        gaScript.src = "https://www.googletagmanager.com/gtag/js?id=" + response.googleAnalyticsCode;
                        document.head.appendChild(gaScript);

                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', response.googleAnalyticsCode);
                    }

                    if (response.facebookPixelCode) {
                        !function(f,b,e,v,n,t,s)
                        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)}(window,document,'script',
                        'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', response.facebookPixelCode);
                        fbq('track', 'PageView');
                    }

                    if (response.googleAdsCode) {
                        const gadsScript = document.createElement('script');
                        gadsScript.async = true;
                        gadsScript.src = "https://www.googletagmanager.com/gtag/js?id=" + response.googleAdsCode;
                        document.head.appendChild(gadsScript);

                        window.dataLayer = window.dataLayer || [];
                        function gtag(){dataLayer.push(arguments);}
                        gtag('js', new Date());
                        gtag('config', response.googleAdsCode);
                    }
                    
                    
                } catch (error) {
                    console.error(error);
                }
            } else {
                document.title = this.finalWebsite.title;
                
                const link = document.createElement('link');
                link.rel = 'icon';
                link.href = this.finalWebsite.faviconFinal;
                document.head.appendChild(link);
                
                if (this.finalWebsite.css) {
                    const style = document.createElement('style');
                    style.textContent = this.finalWebsite.css;
                    document.head.appendChild(style);
                }
                
                if (this.finalWebsite.javascript) {
                    const script = document.createElement('script');
                    script.textContent = this.finalWebsite.javascript;
                    document.body.appendChild(script);
                }
            }
        },
    },
    beforeDestroy() {
        this.removeOverflow();
    },
    created(){
        this.getInfoSite();
        this.storeNoLogin({noLogin:false});
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.isMobile = window.innerWidth <= 768;
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', () => {
            this.isMobile = window.innerWidth <= 768;
        });
    }
}
</script>

<style scoped>
body.no-scroll {
    overflow: hidden;
}
header{
    backdrop-filter: blur(10px);
    background-color: rgba(20, 20, 20, 0.64);
    z-index: 99;
    height: 60px;
}
.header {
    height: 64px;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    max-width: 1500px;
    margin: 0 auto;
}
.contentHeaderLeft {
    display: flex;
    align-items: center;
    gap: 20px;
}
.contentHeaderLeft img{
    width: 120px;
}
.contentHeaderLeft p{
    margin: 0;
    color: white;
    font-size: 15px;
}
.contentHeaderLeft p a{
   text-decoration: none;
   color: white;
}

.company-selector {
    width: 200px;
}

.company-selector .v-select {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    color: white;
}

.company-selector .vs__dropdown-toggle {
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: transparent;
}

.company-selector .vs__selected {
    color: white;
}

.company-selector .vs__search::placeholder {
    color: rgba(255, 255, 255, 0.5);
}

.company-selector .vs__dropdown-menu {
    background: rgba(20, 20, 20, 0.95);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: white;
}

.company-selector .vs__dropdown-option {
    color: white;
}

.company-selector .vs__dropdown-option--highlight {
    background: rgba(255, 255, 255, 0.1);
}

.contentHeaderMiddle {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
}
.contentHeaderMiddle p {
    margin: 0;
    color: white;
 }
.contentHeaderMiddle p a{
    text-decoration: none;
    color: white;
 }
header {
    position: absolute;
    top: 0;
    width: 100%;
}
.contentHeaderMiddle > div >button.btnHedaer {
    padding: 0px 16px;
    color: rgb(255, 255, 255);
    display: block;
    text-align: center;
    line-height: 27px;
    font-weight: 800;
    text-transform: uppercase;
    background-color: black;
    border-radius: 10px;
    background-color: #260791;
    padding: 1px 10px;
    border-radius: 4px;
    font-size: 13px;
}
.search {
    transition: all 0.3s ease 0s;
    border-radius: 5px;
}
.search.active {
    background-color: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 5px;
}
.search input {
    height: 100%;
    color: white;
    width: 300px;
    font-size: 14px;
    width: 0;
    transition: all 0.3s ease 0s;
}
.search.active input {
   width: 300px;
   padding: 0 10px;

}
input:focus-visible {
    outline: none;
    box-shadow: none;
}
button.btnCloseSearch svg {
    font-size: 15px;
}
button.btnCloseSearch {
    margin-right: 15px;
}
.search.active button.btnSearch {
    background-color: #2c2c2f;
    height: 40px;
    width: 40px;
    border: none;
}
button.btnSearch {
    height: 40px;
    width: 40px;
}
.login{
    cursor: pointer;
}
.menuMobile {
    cursor: pointer;
}
.linkMenu {
    margin: 0;
    padding: 15px;
    color: #8e8e8e;
    transition: all 500ms ease-in-out;
    cursor: pointer;
    background-color: transparent;
    text-decoration: none;
    display: block;
}
.resultSearchItens {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    display: block;
}
.notFound p {
    color: #333;
    text-align: center;
    margin: 20px;
    font-size: 16px;
}
.resultSearch {
    z-index: -1!important;
    position: absolute!important;
    top: 60px!important;
    background-color: #000000e0!important;
    height: 100vh!important;
    width: 100%!important;
    opacity: 0!important;
}
.resultSearch.active {
    opacity: 1 !important;
    z-index: 9999!important;
}
.InfoOutLogin {
    display: contents;
}
.lgooContentCenter {
    position: absolute;
    top: 5px;
    left: 50%;
}
.search.active input[type="text"] {
    color: rgb(255, 255, 255);
}

.contentHeaderMiddle p a{
    text-decoration: none;
    color: #7f7f7f;
 }
 .resultSearch.mobile.active {
    z-index: 88!important;
    position: absolute!important;
    top: 0px!important;
    background-color: #000000e0!important;
    height: 80vh!important;
    width: 100%!important;
    opacity: 1!important;
    padding-top: 75px!important;
}
.siteTheme2 svg.svg-inline--fa {
    color: #8e8e8e;
}
.tab-content {
    height: 700px;
    overflow: scroll;
    -ms-overflow-style: none; 
    scrollbar-width: none;  
}
.tab-content::-webkit-scrollbar {
    display: none; 
}

.tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.tab-btn {
    padding: 10px 20px;
    margin: 0 10px;
    border: none;
    background: #a8a8a8;
    cursor: pointer;
    border-radius: 5px;
    font-size: 16px;
}

.tab-btn.active {
    background: v-bind("finalWebsite?.color || '#4CAF50'");
    color: white;
}

.grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding: 20px;
}

.grid-item {
    background: #1d1d1d;
    border-radius: 8px;
    overflow: hidden;
    transition: transform 0.2s;
}

.grid-item:hover {
    transform: translateY(-5px);
}

.item-content {
    padding: 10px;
    cursor: pointer;
}

.item-content img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 4px;
}

.item-content p {
    margin: 10px 0;
    font-size: 14px;
    color: #ffffff;
    text-align: left;
}

@media (max-width: 1200px) {
    .grid-container {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 900px) {
    .grid-container {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px) {
    .grid-container {
        grid-template-columns: 1fr;
        padding-bottom: 180px !important;
    }

    .grid-item {
        width: 100%;
    }
    .sidebar-nav {
        gap: 0px !important;
    }
    .user-menu {
        gap: 0px!important;
    }
}
p.login {
    border-radius: 4px;
}
p.login svg {
    font-size: 20px;
}
.mobile-header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    background-color: rgba(20, 20, 20, 0.95);
    backdrop-filter: blur(10px);
}

.mobile-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    height: 60px;
}

.mobile-logo img {
    height: 40px;
    width: auto;
}

.menu-toggle {
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    padding: 5px;
}

.mobile-sidebar {
    position: fixed;
    top: 0;
    right: -100%;
    width: 80%;
    height: 100vh;
    background-color: rgba(20, 20, 20, 0.98);
    transition: right 0.3s ease;
    z-index: 1001;
    padding: 20px;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
}
.degragre-background-sidebar-mobile {
    width: 100%;
    height: 100vh;
    content: '';
    background-color: #000000bf;
    display: block;
    z-index: -5;
    position: absolute;
    top: 0;
    right: 51px;
    transition: all 0.3s ease;
}
.mobile-sidebar.active {
    right: 0;
}

.sidebar-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
    position: absolute;
    right: 0;
    top: 9px;
}

.close-menu {
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    padding: 5px;
}

.sidebar-nav {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.sidebar-nav a {
    color: white;
    text-decoration: none;
    font-size: 15px;
    text-align: left;
    padding: 10px 0;
    display: flex;
    gap: 10px;
    align-items: anchor-center;
    justify-content: flex-start;
}

.mobile-search {
    position: relative;
    margin: 20px 0;
}

.mobile-search input {
    width: 100%;
    padding: 10px;
    background-color: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 5px;
    color: white;
}

.search-btn {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: white;
    cursor: pointer;
}

.close-search-btn {
    position: absolute;
    right: 40px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: white;
    cursor: pointer;
}

.mobile-login {
    display: flex;
    align-items: center;
    gap: 10px;
    color: white;
    cursor: pointer;
    padding: 10px 0;
}

.user-menu {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.user-menu a,
.user-menu button {
    display: flex;
    align-items: center;
    gap: 10px;
    color: white;
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    padding: 10px 0;
    text-decoration: none;
}

.subscribe-btn {
    width: 100%;
    padding: 12px;
    background-color: #260791;
    color: white;
    border: none;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
    margin: 10px 0;
}

body.no-scroll {
    overflow: hidden;
}

header{
    backdrop-filter: blur(10px);
    background-color: rgba(20, 20, 20, 0.64);
    z-index: 99;
    height: 60px;
}
.loggedInfo .itensMenu {
    background-color: #232323;
    padding: 6px;
    text-align: left;
}

.loggedInfo .itensMenu.active {
    width: 200px;
    position: absolute;
    right: 1%
}
.loggedInfo .itensMenu {
    width: 10%;
    position: absolute;
    right: -60%;
}
.loggedInfo {
    max-width: 1500px;
    margin: 0 auto;
    position: relative;
    display: block;
    width: 100%;
}
.grid-item:hover .gif-indicator {
    display: block;
    transform: translateY(0px) !important;
    transform: scale(1.2) !important;
    filter: brightness(2) !important;
    opacity: 1 !important;
    transition: all 1s ease-in-out !important;
    height: 200px !important;
    border-radius: 5px;
}
.title-sidebar-mobile {
    text-align: left;
    color: white;
    width: 90%;
}
@media (max-width: 600px) {
    .sidebar-nav {
        margin-top: 40px;
    }
    .mobile-search input {
        padding: 5px 10px;
    }
}
</style>
<style scoped>
.plans-side-mobile {
    margin: 10px 0;
    padding: 10px 0;
    border-top: 1px solid rgba(255,255,255,0.1);
    border-bottom: 1px solid rgba(255,255,255,0.1);
}
.plan-item {
    background: rgba(255,255,255,0.05);
    padding: 10px;
    margin: 5px 0;
    border-radius: 4px;
}
.plan-name {
    font-weight: bold;
    color: #fff;
    font-size: 14px;
}
.plan-price {
    color: #ffffff;
    font-size: 16px;
    font-weight: bold;
    margin: 5px 0;
}
.plan-period {
    color: #999;
    font-size: 12px;
}
@media screen and (max-width: 600px) {
    button.close-search-btn svg {
        font-size: 13px;
    }
    a.subscribe-btn.sidebar-btn {
        text-align: center !important;
        justify-content: center;
    }
}
</style>